import Ext from 'Ext'
import ReportsSelectorUsersPanel from '../reports/at_reports_selector_users_panel'
import messageResource from '../messageResource'
import OvertimeEmptyMessageBuilder from '../hierarchySelector/userSelector/emptyMessagesBuilders/OvertimeEmptyMessageBuilder'

Ext.namespace("AT");

const OvertimeReportSelectorPanel = Ext.extend(ReportsSelectorUsersPanel, {

    allItemsOptionLabelKey: "users_selector.reports.overtime.all_users",
    allItemsOptionMessageParams: [window.SystemSettings.overtimeNaming],

    createEmptyMessageBuilder: function() {
        return new OvertimeEmptyMessageBuilder(this.userSelectorGroupsStrategy);
    },

    getDetailsSection: function() {
        const res = OvertimeReportSelectorPanel.superclass.getDetailsSection.call(this);
        res.push({ xtype: "box",
                     autoEl: {
                         tag: "span",
                         html: messageResource.getMessage("users_selector.reports.overtime.list_note" ),
                         cls: "label notemsg overtimeInfoTooltip"
                     }});
        return res;
    }

});

Ext.reg("at_overtime_report_selector_panel", ReportsSelectorUsersPanel)

export default OvertimeReportSelectorPanel


// WEBPACK FOOTER //
// ./web/js/usersSelector/at_overtime_report_selector_panel.js